import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const groupsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'groups'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'groups', itemId] as const,
        detail: [...keys, 'groups', itemId, 'detail'] as const,
        import: [...keys, 'groups', itemId, 'import'] as const,
        fees: [...keys, 'groups', itemId, 'fees'] as const,
        students: [...keys, 'groups', itemId, 'students'] as const,
      }),
  });

export { groupsKeys };
